"use client";

import { c as _c } from "react/compiler-runtime";
import { FavoriteButton } from "@/features/hospital/ui/molecules";
import { DirectionIcon, IconButton } from "@/shared/ui/atoms";
interface BottomProps {
  favorite: boolean;
}
const Bottom = t0 => {
  const $ = _c(5);
  const {
    favorite
  } = t0;
  const moveToScrollTop = _temp;
  let t1;
  if ($[0] !== favorite) {
    t1 = <FavoriteButton favorite={favorite} />;
    $[0] = favorite;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconButton onClick={moveToScrollTop}><DirectionIcon size={24} rotate={180} /></IconButton>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className="fixed bottom-0 left-0 right-0 z-[10] w-full max-w-[600px] mx-auto bg-white py-3 px-4 flex items-start justify-between border-t border-gray-200">{t1}{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default Bottom;
function _temp() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}